import { Grid } from '@mui/material'
import { RevokeAccessModuleModel } from '../../../Models'
import { MUIBox, MUICheckbox } from '../../Shared'

interface ModuleSelectionProps {
  modules: RevokeAccessModuleModel[]
  selectedKeys: string[]
  onToggle: (key: string, checked: boolean) => void
  onSelectAll: (checked: boolean) => void
  disabled?: boolean
}

const ModuleSelection = ({
  modules,
  selectedKeys,
  onToggle,
  onSelectAll,
  disabled = false,
}: ModuleSelectionProps) => {
  const allSelected =
    modules.length > 0 && modules.every((modules) => selectedKeys.includes(modules.key))

  return (
    <MUIBox>
      <div className='heading-6 d-flex text-left rolebox__header-padding bg-col5'>
        <div className='d-flex align-items-center'>Bolt Modules</div>
        <div className='ml-auto d-flex'>
          <MUICheckbox
            disabled={disabled}
            handleChange={(e) => onSelectAll(e.target.checked)}
            checked={allSelected}
            label={<span className='paragraph-regular-6'>Select All</span>}
            dataTestId='module-select-all'
          />
        </div>
      </div>
      <div className={'hr'}></div>
      <div>
        <Grid container className='bg-col27'>
          <Grid item xs={6} md={6} lg={6} xl={6}>
            <div className='paragraph-bold-6 d-flex text-left'>
              <Grid container>
                <Grid item xs={8} sm={8} md={8} lg={9} xl={9}>
                  <div className='d-flex align-items-center permissions__box_content-padding'>
                    Permissions
                  </div>
                </Grid>
                <Grid item xs={4} sm={4} md={4} lg={3} xl={3}>
                  <div className='text-center permissions__box_content-padding'>Yes</div>
                </Grid>
              </Grid>
            </div>
          </Grid>
          <Grid item xs={6} md={6} lg={6} xl={6}>
            <div className='paragraph-bold-6 d-flex text-left'>
              <Grid container>
                <Grid item xs={8} sm={8} md={8} lg={9} xl={9}></Grid>
                <Grid item xs={4} sm={4} md={4} lg={3} xl={3}>
                  <div className='text-center permissions__box_content-padding'>Yes</div>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
        <Grid container>
          {modules.map((module) => (
            <Grid item xs={6} md={6} lg={6} xl={6} key={module.key}>
              <div className='paragraph-regular-6 d-flex text-left'>
                <Grid container>
                  <Grid item xs={8} sm={8} md={8} lg={9} xl={9}>
                    <div className='d-flex align-items-center permissions__box_content-padding content'>
                      {module.displayName}
                    </div>
                  </Grid>
                  <Grid item xs={4} sm={4} md={4} lg={3} xl={3} className='bg-col70'>
                    <div className='ml-auto d-flex border justify-content-center align-items-center permissions__box_content-padding content'>
                      <MUICheckbox
                        disabled={disabled}
                        handleChange={(e) => onToggle(module.key, e.target.checked)}
                        label=''
                        checked={selectedKeys.includes(module.key)}
                        dataTestId={`module-checkbox-${module.key}`}
                      />
                    </div>
                  </Grid>
                </Grid>
              </div>
            </Grid>
          ))}
        </Grid>
      </div>
    </MUIBox>
  )
}

export default ModuleSelection
